require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./link"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./link"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./link")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./link"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__26__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[43],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__12__;

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-persistent-banner{display:flex;align-items:center;height:40px;color:#fff;font-size:.875rem}.ba-persistent-banner .ba-persistent-banner-child{display:flex;align-items:center;padding-left:16px;height:100%}.ba-alert-navigator{background-color:#000}", ""]);

// exports
exports.locals = {
	"persistentBannerClassName": "\"ba-persistent-banner\"",
	"persistentBannerChildClassName": "\"ba-persistent-banner-child\"",
	"alertNavigatorClassName": "\"ba-alert-navigator\""
};

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-alert-navigator-label{padding-right:16px}", ""]);

// exports
exports.locals = {
	"alertNavigatorLabelClassName": "\"ba-alert-navigator-label\""
};

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-alert-navigator-buttons{min-width:80px}.ba-alert-navigator-buttons .ba-common-button.is-variant_solid{min-width:40px;width:40px;padding:0;background-color:#343334}.ba-alert-navigator-buttons .ba-common-button.is-variant_solid:hover:not(.is-disabled):not(.is-tap){background-color:#595859}.ba-alert-navigator-buttons .ba-common-button.is-disabled{opacity:1;background-color:#595859}.ba-alert-navigator-buttons .ba-common-button.is-disabled svg{opacity:.5}", ""]);

// exports
exports.locals = {
	"alertNavigatorButtonsClassName": "\"ba-alert-navigator-buttons\""
};

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-alert-message{display:flex;align-items:center;flex-grow:1;padding-right:16px}.ba-alert-message .ba-message-container{display:flex;align-items:center;flex-grow:1}.ba-alert-message .ba-message-container .ba-optional-title{font-weight:600;padding:0 16px 0 8px}.ba-alert-message .ba-message-container .ba-common-svgIcon{min-width:16px}.ba-alert-message .ba-dismiss-container .ba-common-link{color:#fff}.ba-alert-message .ba-dismiss-container .ba-common-link:hover{color:#eaeaea}", ""]);

// exports
exports.locals = {
	"toolTipIconClassName": "\"ba-common-svgIcon\"",
	"alertMessageClassName": "\"ba-alert-message\"",
	"messageContainerClassName": "\"ba-message-container\"",
	"dismissContainerClassName": "\"ba-dismiss-container\"",
	"optionalTitleClassName": "\"ba-optional-title\""
};

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-alert-goto-action.ba-common-button.is-variant_solid{background-color:#000;font-weight:400;padding:0 16px;min-width:fit-content}.ba-alert-goto-action.ba-common-button.is-variant_solid .ba-common-button__label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:106px;max-width:126px}.ba-alert-goto-action.ba-common-button.is-variant_solid:hover:not(.is-disabled):not(.is-tap){background-color:#595859}.ba-alert-goto-action span.ba-common-button__icon.is-right{padding-left:16px}", ""]);

// exports
exports.locals = {
	"alertGoToActionClassName": "\"ba-alert-goto-action\""
};

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-alert-container{background-color:#2d74da;flex-grow:1}", ""]);

// exports
exports.locals = {
	"alertContainerClassName": "\"ba-alert-container\""
};

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-persistent-banner{display:flex;align-items:center;height:40px;color:#fff;font-size:.875rem}.ba-persistent-banner .ba-persistent-banner-child{display:flex;align-items:center;padding-left:16px;height:100%}", ""]);

// exports
exports.locals = {
	"persistentBannerClassName": "\"ba-persistent-banner\"",
	"persistentBannerChildClassName": "\"ba-persistent-banner-child\""
};

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _AlertNavigator = _interopRequireDefault(__webpack_require__(422));

var _AlertNavigatorLabel = _interopRequireDefault(__webpack_require__(186));

var _AlertNavigatorButtons = _interopRequireDefault(__webpack_require__(188));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const alertNavigatorClassName = _AlertNavigator.default.alertNavigatorClassName.replace(/"/g, '');

class AlertNavigator extends _react.Component {
  render() {
    const {
      currentAlert,
      alertsLength,
      className,
      onPrev,
      onNext
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${className} ${alertNavigatorClassName}`
    }, /*#__PURE__*/_react.default.createElement(_AlertNavigatorLabel.default, {
      currentAlert,
      alertsLength
    }), alertsLength > 1 && /*#__PURE__*/_react.default.createElement(_AlertNavigatorButtons.default, {
      currentAlert,
      alertsLength,
      onPrev,
      onNext
    }));
  }

}

exports.default = AlertNavigator;
AlertNavigator.propTypes = {
  currentAlert: _propTypes.default.number.isRequired,
  alertsLength: _propTypes.default.number.isRequired,
  className: _propTypes.default.string,
  onPrev: _propTypes.default.func,
  onNext: _propTypes.default.func
};
AlertNavigator.defaultProps = {
  currentAlert: 0,
  alertsLength: 0,
  className: ''
};

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = AlertNavigatorLabel;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _AlertNavigatorLabel = _interopRequireDefault(__webpack_require__(423));

var _StringResource = _interopRequireDefault(__webpack_require__(187));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const alertNavigatorLabelClassName = _AlertNavigatorLabel.default.alertNavigatorLabelClassName.replace(/"/g, '');

function formatNumAlerts(currentAlert, alertsLength) {
  return `${currentAlert + 1}/${alertsLength}`;
}

function AlertNavigatorLabel(props) {
  const {
    currentAlert,
    alertsLength
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: alertNavigatorLabelClassName
  }, formatNumAlerts(currentAlert, alertsLength), " ", _StringResource.default.get('alerts'));
}

AlertNavigatorLabel.propTypes = {
  currentAlert: _propTypes.default.number.isRequired,
  alertsLength: _propTypes.default.number.isRequired
};
AlertNavigatorLabel.defaultProps = {
  currentAlert: 0,
  alertsLength: 0
};

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _utils = __webpack_require__(5);

var _PersistentBannerResources = _interopRequireDefault(__webpack_require__(424));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_PersistentBannerResources.default);

exports.default = _default;

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = AlertNavigatorButtons;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _button = _interopRequireDefault(__webpack_require__(12));

var _arrowLeft_ = _interopRequireDefault(__webpack_require__(57));

var _arrowRight_ = _interopRequireDefault(__webpack_require__(189));

var _AlertNavigatorButtons = _interopRequireDefault(__webpack_require__(425));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const alertNavigatorButtonsClassName = _AlertNavigatorButtons.default.alertNavigatorButtonsClassName.replace(/"/g, '');

function AlertNavigatorButtons(props) {
  const {
    alertsLength,
    onPrev,
    onNext
  } = props;
  const currentAlert = props.currentAlert + 1;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: alertNavigatorButtonsClassName
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    varient: "icon",
    icon: _arrowLeft_.default.id,
    disabled: currentAlert === 1,
    onClick: onPrev
  }), /*#__PURE__*/_react.default.createElement(_button.default, {
    varient: "icon",
    icon: _arrowRight_.default.id,
    disabled: currentAlert === alertsLength,
    onClick: onNext
  }));
}

AlertNavigatorButtons.propTypes = {
  currentAlert: _propTypes.default.number.isRequired,
  alertsLength: _propTypes.default.number.isRequired,
  onPrev: _propTypes.default.func,
  onNext: _propTypes.default.func
};
AlertNavigatorButtons.defaultProps = {
  currentAlert: 0,
  alertsLength: 0
};

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/arrow--right_16");

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = AlertContainer;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _AlertMessage = _interopRequireDefault(__webpack_require__(191));

var _AlertGoToAction = _interopRequireDefault(__webpack_require__(192));

var _AlertPropTypes = __webpack_require__(53);

var _AlertContainer = _interopRequireDefault(__webpack_require__(428));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const alertContainerClassName = _AlertContainer.default.alertContainerClassName.replace(/"/g, '');

function isEmpty(item) {
  return item === undefined || item === null || item === '';
}

function isActionEmpty(alert) {
  return !alert || !alert.action || isEmpty(alert.action.label) && isEmpty(alert.action.id) && isEmpty(alert.action.url);
}

function AlertContainer(props) {
  const {
    alert,
    className,
    onDismiss,
    onGoToAction
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `${className} ${alertContainerClassName}`
  }, alert && /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    alert: alert,
    onDismiss: onDismiss
  }), !isActionEmpty(alert) && /*#__PURE__*/_react.default.createElement(_AlertGoToAction.default, {
    action: alert.action,
    onGoToAction: onGoToAction
  }));
}

AlertContainer.propTypes = {
  alert: _AlertPropTypes.alertModel,
  className: _propTypes.default.string,
  onDismiss: _propTypes.default.func,
  onGoToAction: _propTypes.default.func
};
AlertContainer.defaultProps = {
  className: ''
};

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = AlertMessage;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _information_ = _interopRequireDefault(__webpack_require__(75));

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _link = _interopRequireDefault(__webpack_require__(26));

var _AlertPropTypes = __webpack_require__(53);

var _AlertMessage = _interopRequireDefault(__webpack_require__(426));

var _StringResource = _interopRequireDefault(__webpack_require__(187));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const alertMessageClassName = _AlertMessage.default.alertMessageClassName.replace(/"/g, '');

const messageContainerClassName = _AlertMessage.default.messageContainerClassName.replace(/"/g, '');

const dismissContainerClassName = _AlertMessage.default.dismissContainerClassName.replace(/"/g, '');

const optionalTitleClassName = _AlertMessage.default.optionalTitleClassName.replace(/"/g, '');

function renderOptionalTitle(title) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    iconId: _information_.default.id
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: optionalTitleClassName
  }, title));
}

function AlertMessage(props) {
  const {
    alert,
    onDismiss
  } = props;

  if (!alert) {
    return false;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: alertMessageClassName
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: messageContainerClassName
  }, alert.title && renderOptionalTitle(alert.title), alert.message), /*#__PURE__*/_react.default.createElement("div", {
    className: dismissContainerClassName
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    onClick: onDismiss
  }, _StringResource.default.get('dismiss'))));
}

AlertMessage.propTypes = {
  alert: _AlertPropTypes.alertModel,
  onDismiss: _propTypes.default.func
};

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = AlertGoToAction;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _button = _interopRequireDefault(__webpack_require__(12));

var _arrowRight_ = _interopRequireDefault(__webpack_require__(189));

var _AlertGoToAction = _interopRequireDefault(__webpack_require__(427));

var _AlertPropTypes = __webpack_require__(53);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const alertGoToActionClassName = _AlertGoToAction.default.alertGoToActionClassName.replace(/"/g, '');

function onClick(action, callback) {
  const {
    url
  } = action;

  if (url) {
    window.open(url, '_blank');
  }

  if (callback) {
    callback(action);
  }
}

function AlertGoToAction(props) {
  const {
    action,
    onGoToAction
  } = props;
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    className: alertGoToActionClassName,
    iconRight: _arrowRight_.default.id,
    label: action.label,
    title: action.label,
    onClick: () => onClick(props.action, onGoToAction)
  });
}

AlertGoToAction.propTypes = {
  action: _AlertPropTypes.alertActionModel,
  onGoToAction: _propTypes.default.func
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__26__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(420);


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _PersistentBanner = _interopRequireDefault(__webpack_require__(421));

exports.default = _PersistentBanner.default;
exports.PersistentBanner = _PersistentBanner.default;

var _AlertContainer = _interopRequireDefault(__webpack_require__(190));

exports.AlertContainer = _AlertContainer.default;

var _AlertNavigator = _interopRequireDefault(__webpack_require__(185));

exports.AlertNavigator = _AlertNavigator.default;

var _AlertNavigatorLabel = _interopRequireDefault(__webpack_require__(186));

exports.AlertNavigatorLabel = _AlertNavigatorLabel.default;

var _AlertNavigatorButtons = _interopRequireDefault(__webpack_require__(188));

exports.AlertNavigatorButtons = _AlertNavigatorButtons.default;

var _AlertMessage = _interopRequireDefault(__webpack_require__(191));

exports.AlertMessage = _AlertMessage.default;

var _AlertGoToAction = _interopRequireDefault(__webpack_require__(192));

exports.AlertGoToAction = _AlertGoToAction.default;

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _AlertNavigator = _interopRequireDefault(__webpack_require__(185));

var _AlertContainer = _interopRequireDefault(__webpack_require__(190));

var _AlertPropTypes = __webpack_require__(53);

var _PersistentBanner = _interopRequireDefault(__webpack_require__(429));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const persistentBannerClassName = _PersistentBanner.default.persistentBannerClassName.replace(/"/g, '');

const persistentBannerChildClassName = `${persistentBannerClassName}-child`;

class PersistentBanner extends _react.Component {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "onDismiss", () => {
      const callback = this.props.onDismiss;

      if (callback) {
        const potentialPromise = callback(this.state.currentAlert);

        if (potentialPromise && potentialPromise.then) {
          return potentialPromise.then(() => {
            this.prev();
          });
        }

        this.prev();
      }

      return Promise.resolve();
    });
    (0, _defineProperty2.default)(this, "prev", () => {
      const {
        currentAlert
      } = this.state;
      this.setState({
        currentAlert: Math.max(currentAlert - 1, 0)
      });
    });
    (0, _defineProperty2.default)(this, "next", () => {
      const {
        currentAlert
      } = this.state;
      const alertsLength = this.props.alerts.length;
      this.setState({
        currentAlert: Math.min(currentAlert + 1, alertsLength - 1)
      });
    });
    this.state = {
      currentAlert: 0
    };
  }

  render() {
    const {
      alerts,
      onGoToAction
    } = this.props;
    const {
      currentAlert
    } = this.state;
    return alerts && alerts.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: persistentBannerClassName
    }, /*#__PURE__*/_react.default.createElement(_AlertNavigator.default, {
      currentAlert: currentAlert,
      alertsLength: alerts.length,
      className: persistentBannerChildClassName,
      onPrev: this.prev,
      onNext: this.next
    }), /*#__PURE__*/_react.default.createElement(_AlertContainer.default, {
      alert: alerts[currentAlert],
      className: persistentBannerChildClassName,
      onDismiss: this.onDismiss,
      onGoToAction: onGoToAction
    }));
  }

}

exports.default = PersistentBanner;
PersistentBanner.propTypes = {
  /** Alert configuration */
  alerts: _propTypes.default.arrayOf(_AlertPropTypes.alertModel),

  /** Dismiss callback - will be called with the alert index when a alert is dismissed. */
  onDismiss: _propTypes.default.func,

  /** GoToAction callback - will be called with the alert.action.id when the goto action is clicked and no url is specified with the action. */
  onGoToAction: _propTypes.default.func
};

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(128);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(129);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

var amdi18n={"__root":{"alerts":"Alerts","dismiss":"Dismiss"},"__cs":{"alerts":"Výstrahy","dismiss":"Opustit"},"__da":{"alerts":"Varsler","dismiss":"Afvis"},"__de":{"alerts":"Alerts","dismiss":"Schließen"},"__es":{"alerts":"Alertas","dismiss":"Descartar"},"__fi":{"alerts":"Hälytykset","dismiss":"Ohita"},"__fr":{"alerts":"Alertes","dismiss":"Fermer"},"__hr":{"alerts":"Uzbune","dismiss":"Odbaci"},"__hu":{"alerts":"Riasztások","dismiss":"Elvetés"},"__it":{"alerts":"Avvisi","dismiss":"Rimuovi"},"__ja":{"alerts":"アラート","dismiss":"解放"},"__kk":{"alerts":"Ескертулер","dismiss":"Бас тарту"},"__ko":{"alerts":"경고","dismiss":"닫기"},"__nb":{"alerts":"Varsler","dismiss":"Avvis"},"__nl":{"alerts":"Alerts","dismiss":"Verwijderen"},"__no":{"alerts":"Varsler","dismiss":"Avvis"},"__pl":{"alerts":"Alerty","dismiss":"Zamknij"},"__pt":{"alerts":"Alertas","dismiss":"Indeferir"},"__pt-br":{"alerts":"Alertas","dismiss":"Indeferir"},"__ro":{"alerts":"Alerte","dismiss":"Renunţare"},"__ru":{"alerts":"Оповещения","dismiss":"Отбросить"},"__sl":{"alerts":"Opozorila","dismiss":"Opusti"},"__sv":{"alerts":"Varningar","dismiss":"Avvisa"},"__th":{"alerts":"แจ้งเตือน","dismiss":"ยกเลิก"},"__tr":{"alerts":"Uyarılar","dismiss":"Kapat"},"__zh":{"alerts":"警报","dismiss":"关闭"},"__zh-cn":{"alerts":"警报","dismiss":"关闭"},"__zh-hk":{"alerts":"警示","dismiss":"跳出"},"__zh-mo":{"alerts":"警示","dismiss":"跳出"},"__zh-sg":{"alerts":"警报","dismiss":"关闭"},"__zh-tw":{"alerts":"警示","dismiss":"跳出"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(132);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(133);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(134);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.sampleAlertWithActionById = exports.sampleAlertWithEmptyLabelAction = exports.sampleAlertWithEmptyAction = exports.sampleAlertWithAction = exports.sampleAlertwithTitle = exports.sampleSimpleAlert = exports.alertModel = exports.alertActionModel = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(4));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const alertActionModel = _propTypes.default.shape({
  id: _propTypes.default.string,
  label: _propTypes.default.string.isRequired,
  url: _propTypes.default.string
});

exports.alertActionModel = alertActionModel;

const alertModel = _propTypes.default.shape({
  id: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  message: _propTypes.default.string.isRequired,
  action: alertActionModel
}).isRequired;

exports.alertModel = alertModel;
const sampleSimpleAlert = {
  id: '123',
  message: "Check out what's new"
};
exports.sampleSimpleAlert = sampleSimpleAlert;
const sampleAlertwithTitle = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new"
};
exports.sampleAlertwithTitle = sampleAlertwithTitle;
const sampleAlertWithAction = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: 'Go to release notes',
    url: 'http://www.ibm.com'
  }
};
exports.sampleAlertWithAction = sampleAlertWithAction;
const sampleAlertWithEmptyAction = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: ''
  }
};
exports.sampleAlertWithEmptyAction = sampleAlertWithEmptyAction;
const sampleAlertWithEmptyLabelAction = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: '',
    id: '111'
  }
};
exports.sampleAlertWithEmptyLabelAction = sampleAlertWithEmptyLabelAction;
const sampleAlertWithActionById = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: 'Go to release notes',
    id: 'openGlobalToast'
  }
};
exports.sampleAlertWithActionById = sampleAlertWithActionById;

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/arrow--left_16");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/information_16");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[419,0]]]);
});